import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { useAxios } from "../useAxios";
import { QuizGlobalStatisticsDto, QuizStatisticsFilter } from "../../types/quiz-statistics";

export const useGetQuizStatistics = (filter: QuizStatisticsFilter, enabled = true) => {
  const axios = useAxios();
  const { t } = useTranslation();

  const fetchStats = async (): Promise<QuizGlobalStatisticsDto> => {
    try {
      const params = new URLSearchParams();
      if (filter.startDate) params.append("startDate", filter.startDate);
      if (filter.endDate) params.append("endDate", filter.endDate);

      const query = params.toString() ? `?${params.toString()}` : "";
      const { data } = await axios.get(`/api/challenges/GlobalStatistics${query}`);
      return data;
    } catch (error) {
      throw new Error(t("quizStatistics.errors.fetchFailed"));
    }
  };

  return useQuery({
    queryKey: ["quizGlobalStatistics", filter],
    queryFn: fetchStats,
    enabled,
    refetchInterval: 15_000,
  });
};
